import loadModuleScript from "./moduleScript";
const addresses = {
    data() {
        return {
            modules: {},
            addresses: [],
            countries: [],
        };
    },
    methods: {
        getData() {
            let loginToken = Cookies.getItem("login_token");
            if(!loginToken){
                location.href = (window.SHOP_BASE || "") + "/login";
                return;
            }
            ProfileSession.userInfo(loginToken, true).then((userInfo) => {
                if (userInfo) {
                    this.setUserAddressInfo(userInfo);
                }
            });
        },
        setUserAddressInfo(userInfo) {
            this.countries = userInfo.countries;
            if (userInfo.crmItemAddresses.length) {
                this.addresses = userInfo.crmItemAddresses.map((el) => {
                    return {
                        id: el.id,
                        userId: el.crm_item_id,
                        countryId: el.country_id,
                        postalCode: el.post_code,
                        city: el.city,
                        street: el.street,
                        house: el.house,
                    };
                });
            } else {
                this.addresses = [];
            }
        },
        saveToLocalStorage(userInfo) {
            let token = Cookies.getItem("login_token");
            if (token) {
                localStorage.setItem(token, JSON.stringify(userInfo));
            }
        },
        loadModalModule(name, addressId) {
            let modules = this.modules;
            const _this = this;
            this.loadModule(name, function () {
                modules[name].openModal(addressId,_this.countries);
            });
        },
        loadDialogModule(name, addressId, userId) {
            let modules = this.modules;
            this.loadModule(name, () => {
                this.modules[name].openDialog(() => {
                    this.deleteAddress(addressId, userId);
                });
            });
        },
        deleteAddress(addressId, userId) {
            if (!addressId) return;
            let token = Cookies.getItem("login_token");
            let bodyContent = {
                token: token,
                address_id: addressId,
                user_id: userId,
            };
            fetch("/api/profile/delete-address", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(bodyContent),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    if (data.code === 200) {
                        let userInfo = JSON.parse(localStorage.getItem(token));
                        let addresses = userInfo.crmItemAddresses;
                        addresses.splice(
                            addresses.findIndex((el) => el.id == addressId),
                            1
                        );
                        userInfo.crmItemAddresses = addresses;
                        console.log(userInfo, addressId);
                        this.setUserAddressInfo(userInfo);
                        this.saveToLocalStorage(userInfo);
                        this.modules["deleteDialog"].closeDialog();

                        setTimeout(function () {
                            alert("deleted successfully!");
                        }, 0);
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
        loadModule(name, callback) {
            this.module = name;
            if (this.modules[name] === undefined) {
                loadModuleScript(name).then(() => {
                    if (this.modules[name] === undefined) {
                        this.modules[name] = window[`${name}App`].mount(`#${name}`);
                        forms.load();
                    }
                    if (callback) callback();
                });
            } else {
                if (callback) callback();
            }
        },
    },
    created() {
        this.getData();
    },
    computed: {
        refresh() {
            if (this.modules["addressModal"]) {
                return this.modules["addressModal"].get("refresh");
            } else {
                return false;
            }
        },
    },
    watch: {
        refresh(value) {
            if (value) {
                this.getData();
                this.modules["addressModal"].set("refresh", false);
            }
        },
    },
};

// Global cart object
const ADDRESSES = {
    vue: null,
    loaded: false,
    load() {
        if (this.loaded) {
            return;
        }
        if (document.getElementById("addresses") !== null) {
            this.loaded = true;
            this.vue = Vue.createApp(addresses).mount("#addresses");
            forms.load();
        }
    },
};
window.ADDRESSES = ADDRESSES;

window.addEventListener("DOMContentLoaded", () => {
    ADDRESSES.load();
});
window.addEventListener("load", () => {
    ADDRESSES.load();
});

if (document.readyState !== "loading") {
    ADDRESSES.load();
}
